import styles from './SCarDetaiImagesSection.module.scss';

const SCarDetaiImagesSection = ({ rightImage, leftTopImage, leftBottomImage }) => {
  // 获取图片URL的辅助函�?
  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    // 优先使用desktopImage
    const desktopImage = imageField.fields.desktopImage?.value?.src;
    const mobileImage = imageField.fields.mobileImage?.value?.src;
    const tabletImage = imageField.fields.tabletImage?.value?.src;

    return desktopImage || tabletImage || mobileImage || '';
  };

  const leftTopImageUrl = getImageUrl(leftTopImage);
  const leftBottomImageUrl = getImageUrl(leftBottomImage);
  const rightImageUrl = getImageUrl(rightImage);

  return (
    <div className={styles.imagesSection} data-aos="fade-up">
      <div className={styles.leftImages}>
        {leftTopImageUrl && <img src={leftTopImageUrl} alt="photo 1" />}
        {leftBottomImageUrl && <img src={leftBottomImageUrl} alt="photo 2" />}
      </div>

      <div className={styles.rightImage}>
        {rightImageUrl && <img src={rightImageUrl} alt="photo 3" />}
      </div>
    </div>
  );
};

export default SCarDetaiImagesSection;
